// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35ofG","footer":"styles_footer__2gxcN"};